import { Layout, Menu } from 'antd'
import * as React from 'react'
import { useState } from 'react'
import { menuData } from 'src/component/app/sidebar/menuData'
import { useUser } from 'src/context/UserContext'
import { isMenuItemAllowedForUser, menuItem } from 'src/util/Util'
import './style.css'

const SubMenu = Menu.SubMenu
const Sider = Layout.Sider

interface SidebarProps {
    selectedKeys: string[],
    openKeys: string[],
    handleClick: (x) => void,
    onOpenChange: (x) => void
}

export const Sidebar: React.FC<SidebarProps> = ({ selectedKeys, openKeys, handleClick, onOpenChange }) => {

    const { user } = useUser()

    const [collapsed, setCollapsed] = useState(false)

    const generateMenuPartitions = (items) => {
        return items
            .filter(menu => isMenuItemAllowedForUser(user, menu))
            .map(item => {
                return generateMenuItem(item)
            }
            )
    }

    const generateMenuItem = (item) => {
        const { key, title, url, icon, children } = item
        if (children) {
            return (
                <SubMenu key={key} title={
                    <span className="menuLeft__title-wrap" key={key}>
                        <span className="menuLeft__item-title">{title}</span>
                        {icon && <span className={icon + ' menuLeft__icon'} />}
                    </span>}>
                    {children
                        .filter(menu => isMenuItemAllowedForUser(user, menu))
                        .map(child => (
                            <Menu.Item key={child.key}>
                                {menuItem(url + child.url, child.title)}
                            </Menu.Item>
                        )
                        )
                    }
                </SubMenu>
            )
        } else {
            return (
                <Menu.Item key={key}>
                    {menuItem(url, title, icon)}
                </Menu.Item>
            )
        }
    }

    const menuItems = generateMenuPartitions(menuData)
    const paramsDesktop = {
        width: 255,
        collapsible: true,
        collapsed: collapsed,
        onCollapse: setCollapsed
    }

    return (
        <Sider {...paramsDesktop} breakpoint="xxl" className="menuLeft">
            <div className="menuLeft__logo">
                {paramsDesktop.collapsed ? (
                    <div className="menuLeft__logoContainer--collapsed">
                        <img src="/resources/images/mobile_logo.svg" alt="" />
                    </div>
                ) : (
                    <div className="menuLeft__logoContainer">
                        <img src="/resources/images/logo.svg" alt="" />
                    </div>
                )}
            </div>
            <div className="sidebar-scrollbar-handler" style={{ height: 'calc(100vh - 112px)', overflowY: 'scroll' }}>
                <Menu
                    theme="dark"
                    mode="inline"
                    // defaultOpenKeys={this.openKeys}
                    openKeys={openKeys}
                    selectedKeys={selectedKeys}
                    className="menuLeft__navigation"
                    onClick={handleClick}
                    onOpenChange={onOpenChange}
                >
                    {menuItems}
                </Menu>
            </div>
        </Sider>
    )
}
